import Vue from 'vue';
import Vuex from 'vuex';
import router from '@/router';
import axiosAuth from '@/axios-auth';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        navAppTitle: 'Sistema de Información Pediátrica',
        navMainLogo: require('@/assets/sip.png'),
        clinicLogo: require('@/assets/gmp.png'),
        sipLogin: require('@/assets/sip_login.png'),
        bWaitCursor: false,
        bSearchingClients: false,
        bFailedLogin: false,
        isAuthenticated: false,
        userName: '', //Nombre del usuario logueado.
        //PEndiente: cambiar línea de abajo:
        selectedUserName: 'Xavier Tortolero', //Nombre del usuario seleccionado en el combo de usuarios.
        selectedUser: null, //Usuario seleccionado en el select del navegador izquierdo.
        selectedUserIndex: -1, //Indice del usuario seleccionado en la ventana Usuarios.
        idToken: null,
        userId: null,
        user: null,
        users: null,
        navClients: [],
        openPatients: [],


        bSearchNewUser: false, //Indica si se debe buscar el índice del usuario que se acaba de registrar.
        newUserEmail: "", //Indica el email de un nuevo usuario registrado, para poder seleccionarlo después en la ventana Usuarios.
        selectedUserIndex: -1, //Indice del usuario seleccionado en la ventana Usuarios.
    },
    mutations: {

        setFailedLogin(state, payload) {
            state.bFailedLogin = payload;
        },
        authUser(state, userData) {
            state.idToken = userData.token;
            state.userId = userData.userId;
        },
        clearAuthData(state) {
            state.idToken = null;
            state.userID = null;
            state.isAuthenticated = false;
        },
        setIsAuthenticated(state, payload) {
            state.isAuthenticated = payload;
        },
        setUser(state, user) {
            state.user = user;
            state.userName = user.nombre + " " + user.apaterno + " " + user.amaterno;
            state.user.admin = user.admin;
        },
        setSelectedUser(state, user) {

            //console.log("Usuario nuevo seleccionado: ", user);
            state.selectedUserName = user.name;
            state.selectedUser = {
                id: user.id,
                name: user.name
            }
            //console.log("selectedUSer = ", state.selectedUser);
            //console.log("selected User Name: ", state.selectedUserName);
        },

        setUsers(state, users) {
            if (state.users !== null) {
                state.users.length = 0;
            }

            state.bWaitCursor = true;
            state.users = users;

            var i;
            for (i = 0; i < users.length; i++) {
                const user = {
                    name: users[i].apaterno + " " + users[i].amaterno + " " + users[i].nombre,
                    //name: users[i].lastName1 + " " + users[i].name,
                    id: users[i].usuariosid
                };

                if (state.bSearchNewUser) {
                    if (state.newUserEmail === users[i].correo) {
                        //console.log("Nuevo usuario identificado, ", users[i].email);
                        state.selectedUserIndex = i;
                        state.bSearchNewUser = false;
                        state.newUserEmail = "";
                    }
                }
            }
            state.bWaitCursor = false;
        },
        addNewUser(state, newUser) {
            state.users.push(newUser);
        },
        updateSelectedUserIndex: (state, index) => {
            state.selectedUserIndex = index;
        },
        navSetClientArray: (state, clients) => {
            //console.log("payload en Mutation navSetClientArray= ", clients);

            state.bSearchingClients = true;

            state.navClients = clients;
            state.bSearchingClients = false;
        },
        navClearClients: (state) => {
            state.navClients = [];
        },
    },
    actions: {
        login({ commit, dispatch, state }, authData) {
            state.bWaitCursor = true;

            //Autenticación en FireBase:
            axiosAuth.post('/verifyPassword?key=AIzaSyCnrO14F_HBZXNe9uNyST_qxMJ6WU6o51w',
                {
                    email: authData.email,
                    password: authData.password,
                    returnSecureToken: true
                })
                .then(res => {
                    console.log("Autenticación en FireBase OK, res = ", res);
                    commit('authUser', {
                        token: res.data.idToken,
                        userId: res.data.localId
                    });
                    commit('setIsAuthenticated', true);
                    //Carga al usuario logueado:
                    dispatch('userLogin', authData.email);

                    const now = new Date();
                    const expirationDate = new Date(now.getTime() + (res.data.expiresIn * 1000)); //Con getTime() se obtiene el tiempo en milisegundos
                    localStorage.setItem('token', res.data.idToken);
                    localStorage.setItem('userId', res.data.localId);
                    localStorage.setItem('expirationDate', expirationDate);
                    localStorage.setItem('userEmail', res.data.email);
                    dispatch('setLogoutTimer', res.data.expiresIn);

                    state.bWaitCursor = false;
                    router.push('/');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    commit('authUser', {
                        token: null,
                        userId: null
                    });
                    commit('setIsAuthenticated', false);
                    commit('setFailedLogin', true);

                });
        },
        setLogoutTimer({ commit }, expirationTime) {
            setTimeout(() => {
                commit('clearAuthData');
                router.replace('/sign-in');//Aparentemente es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
            }, expirationTime * 1000)
        },
        logout({ commit, state }) {
            axios.delete('/sesion/deleteSession/' + state.idToken); //Borra la sesión
            commit('clearAuthData');
            localStorage.removeItem('token');
            localStorage.removeItem('userId');
            localStorage.removeItem('expirationDate');
            localStorage.removeItem('userEmail');
            router.replace('/sign-in');//Se supone que es mejor replace que push porque con replace el usuario no puede irse hacia atrás.
        },
        tryAutoLogin({ commit, dispatch }) {
            const token = localStorage.getItem('token');
            if (!token) {
                return;
            }
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            const now = new Date();

            if (now >= expirationDate) {
                return;
            }
            const userId = localStorage.getItem('userId');
            this.commit('authUser', {
                token: token,
                userId: userId
            });

            const userEmail = localStorage.getItem('userEmail');
            commit('setIsAuthenticated', true);

            //Carga al usuario logueado:
            dispatch('userLogin', userEmail);

            router.push('/');
        },
        userLogin({ commit, dispatch, state }, email) {
            if (!state.idToken) {
                return;
            }

            axios.get('/sesion/' + state.idToken + '/' + email, { crossDomain: true })

                .then(res => {
                    console.log("res de userLogin: ", res);

                    //error 0 = No hay error.
                    if (res.data.error === 1) {
                        console.log("Error. Sesión no válida.");
                        dispatch('logout');
                    }
                    else {
                        const user = res.data;
                        console.log("user = ", user);
                        commit('setUser', user);

                        //Carga todas las tablas de configuración:

                    }
                })
                .catch(error => {
                    alert("Error en login: " + error);
                    console.log("Error en login: ", error);
                    dispatch('logout');
                });
        },
        updateShowUserConfigDlg({ commit }, bShowDlg) {
            commit('setUserConfigDlg', bShowDlg);
        },
        fetchUsers({ commit, state }) {
            state.bWaitCursor = true;

            axios.get('/usuarios/' + state.idToken, { crossDomain: true })
                .then(res => {
                    const data = res.data;
                    console.log("res de usuarios: ", data);
                    const users = [];
                    var i;
                    for (i = 0; i < data.length; i++) {
                        const user = data[i];
                        users.push(user);
                    }
                    state.bWaitCursor = false;
                    commit('setUsers', users);
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },

        signup({ dispatch, state }, newUser) {
            state.bWaitCursor = true;

            //Registra al usuario nuevo en la tabla de autenticación:
            axiosAuth.post('/signupNewUser?key=AIzaSyCnrO14F_HBZXNe9uNyST_qxMJ6WU6o51w', {
                email: newUser.email,
                password: newUser.password,
                returnSecureToken: true
            })
                .then(res => {
                    state.bWaitCursor = false;
                    //Registra al usuario nuevo en la tabla Usuarios:
                    dispatch('saveNewUser', {
                        id: 0,
                        name: newUser.name,
                        lastName1: newUser.lastName1,
                        lastName2: newUser.lastName2,
                        userTypeID: newUser.userTypeID,
                        email: newUser.email,
                        dependencyID: state.dependencyID
                    });
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                });
        },
        saveNewUser({ dispatch, state }, newUser) {
            if (!state.idToken) {
                return;
            }

            state.bWaitCursor = true;
            state.bSearchNewUser = true;
            state.newUserEmail = newUser.email;

            axios.post('/users/' + state.idToken, newUser)
                //axios.post('/users/', newUser)
                .then(res => {
                    state.bWaitCursor = false;
                    //console.log("res de CreateUser: ", res);
                    //Se vuelve a pedir al servidor todos los usuarios:
                    dispatch('fetchUsers');
                })
                .catch(error => {
                    console.log(error);
                    state.bWaitCursor = false;
                    state.bSearchNewUser = false;
                })
        },
        updateSelectedUserIndex({ commit }, index) {
            commit('updateSelectedUserIndex', index);
        },
        navSearchClient: ({ commit, state }, searchString) => {

            // state.bWaitCursor = true;
            //state.bSearchingClients = true;
            state.navClients.length = 0;

            // axios.get('/clients/searchClient/' + searchString + "/" + state.idToken, { crossDomain: true })
            //     .then(res => {
            //         console.log("res de searchClient: ", res);
            //         const data = res.data;
            //         const clients = [];
            //         var i;
            //         for (i = 0; i < data.length; i++) {
            //             if (data[i].error !== 0) {
            //                 alert("Error");
            //             }
            //             const client = data[i];
            //             clients.push(client);
            //         }
            //         state.bWaitCursor = false;
            //         state.bSearchingClients = false;
            //         commit('navSetClientArray', clients);
            //     })
            //     .catch(error => {
            //         console.log(error);
            //         state.bWaitCursor = false;
            //         state.bSearchingClients = false;
            //     });

            //PENDIENTE: Quitar todo el bloque siguiente:
            console.log("navSearchClient, cliente a buscar = ", searchString);
            const clients = [];
            const client = {
                name: "Julio",
                lastName1: "Gómez",
                lastName2: "Rodríguez"
            }
            clients.push(client);
            commit('navSetClientArray', clients);
        },
        navClearClients: ({ commit }) => {
            commit('navClearClients');
        }
    },
    getters: {
        navAppTitle: state => {
            return state.navAppTitle;
        },
        navMainLogo: state => {
            return state.navMainLogo;
        },
        clinicLogo: state => {
            return state.clinicLogo;
        },
        navClients: state => {
            return state.navClients;
        },
        sipLogin: state => {
            return state.sipLogin;
        },
        waitCursor: state => {
            return state.bWaitCursor;
        },
        failedLogin: state => {
            return state.bFailedLogin;
        },
        isAuthenticated(state) {
            return ((state.idToken !== null) && (state.idToken !== undefined));
        },
        selectedUserName: state => {
            return state.selectedUserName;
        },
        user(state) {
            return state.user;
        },
        userName(state) {
            return state.userName;
        },
        isAdmin(state) {
            //return state.user.admin;
            return true;
        },
        users(state) {
            return state.users;
        },
        selectedUserIndex: state => {
            return state.selectedUserIndex;
        },
        openPatients: state => {
            return state.openPatients;
        }
    }
});
